<template>
<div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-campaings-ani-groups'})"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Ani Group</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'company-admin-campaings-ani-groups'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addAniGroup">Add Ani Group</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
        <span class="container-title">Add Ani Group</span>
        <div class="col-wrapper">
          <div class="col">
            <primary-input type="text"
                           name="ani group name"
                           class="field"
                           v-model="aniGroup.ani_group_name"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('first name')}"
                           placeholder="Enter ani group name" />
            <div class="help is-danger"
                 v-if="errors.has('ani group name')">
              {{ errors.first('ani group name') }}
            </div>
            <div class="help is-danger"
                 v-if="aniGroupError">
              {{aniGroupError.ani_group_name ? aniGroupError.ani_group_name[0] : null}}
            </div>
            <!-- <primary-input type="text"
                           name="number"
                           class="field"
                           v-model="number"
                           v-validate="'required|regex:^[0-9]+'"
                           :class="{'input': true, 'is-danger': errors.has('first name')}"
                           placeholder="Enter numbers separated by comma" /> -->
            <div class="list primary-input-container" v-if="anis">
              <p class="pimary-input-title">Select Numbers</p>
              <multiselect v-model="aniGroup.items"
                          name="number"
                          v-validate="'required'"
                          :options="anis"
                          :value="anis"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          class="field"
                          placeholder="Pick Number"
                          label="number"
                          track-by="number"
                          :preselect-first="true">
                <template slot="selection"
                          slot-scope="{ values, search, isOpen, option }">
                  <span class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} numbers selected
                  </span>
                </template>
              </multiselect>
            </div>
            <div class="help is-danger"
                 v-if="errors.has('number')">
              {{ errors.first('number') }}
            </div>
            <div class="help is-danger"
                 v-if="aniGroupError">
              {{aniGroupError.number ? aniGroupError.number[0] : null}}
            </div>   
          </div>         
        </div>
    </div>
</div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
  },
  data: () => ({
    aniGroupError: null,
    aniGroupName: null,
    number: null,
    aniGroup: {
        ani_group_name: null,
        items: []
    },
    items: [],
    anis: [],
    selctedNumbers: [],
  }),
  created() {
    this.getNumberList();
  },
  methods: {
    getNumberList() {
      this.$store.dispatch("GetAllDids",{did_type : 'ANI'})
      .then((res) => {
        console.log("res.items[1]", res.items)
        res.items.map( i => { 
          if(i.using){
            this.anis.push({ 'number' : i.using.did_number})
          }          
        }) //using.did_number
        console.log("anis", this.anis)
      });
    },
    addAniGroup() {      
      this.$validator.validate().then(result => {
        if (result) {          
          this.aniGroup.items = this.aniGroup.items.map(i => i.number);
          // this.number = this.number.replace(/ +?/g, '');
          // console.log("splittttttttttedddddddddddd", this.number);
          // console.log("splitttttttttt", this.number.split(','));
          // this.aniGroup.items = this.number.split(',');
          // this.aniGroup.items = this.aniGroup.items.filter(Boolean);
          // this.aniGroup.items = this.aniGroup.items.filter(item => '"' + item + '"');
          console.log("this.aniGroup", this.aniGroup)
          this.$store
            .dispatch("AddAniGroup", 
                this.aniGroup
            )
            .then(() => {
              this.$snotify.success("Ani Group have been added.", {
                timeout: 6000
              });
                this.$router.push({ name: "company-admin-campaings-ani-groups" });
            })
            .catch(err => {
              if (err.errors) {
                this.aniGroupError = err.errors[0].aniGroup
                  ? err.errors[0].aniGroup
                  : null;
                setTimeout(() => {
                  this.aniGroupError = null;
                }, 6000);
              } else {
                if(err.response.data.error) {
                   this.$snotify.error(err.response.data.error.message, {
                    timeout: 6000
                  });
                } else {
                  this.$snotify.error(err.response.data.errors, {
                    timeout: 6000
                  });
                }
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container{
    font-family: "Helvetica Neue";
    padding: 0 20px;
    .add-navigation {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
      .back-link {
        cursor: pointer;
        display: flex;
        align-items: center;
        fill: #51a3f3;
        color: #51a3f3;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        p {
          margin-bottom: 0;
        }
      }
      .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
          height: 40px;
          width: 146px;
      }
      .secondary-button {
          height: 40px;
          width: 90px;
          margin-right: 20px;
        }
      }
    }
    .add-container {
      flex-direction: column;
      align-items: center;
      height: 375px;
      background-color: #FFFFFF;
      padding-top: 15px;
      .container-title {
          height: 30px;	
          width: 432px;	
          color: #000000;		
          font-size: 18px;	
          font-weight: 500;	
          line-height: 30px;
          padding: 15px 0 15px 15px;
      }
      .col-wrapper {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-left: 15px;
          margin-top: 20px;
          .col {
              width: 100%;
              padding-right: 15px;
              .input {
                  margin-bottom: 20px;
              }
              .field {
                width: 60%;
                p.pimary-input-title {
                  color: #000000;
                  font-family: ""Helvetica Neue"";
                  font-size: 12px;
                  font-weight: 300;
                }
              }
              .list {
                margin-bottom: 20px;
              }
              .pimary-input-title {
                  color: #000000;
                  font-family: "Helvetica Neue";
                  font-size: 12px;
                  font-weight: 900;
                  letter-spacing: 0.21px;
                  line-height: 15px;
                  margin-bottom: 5px;
                  text-transform: uppercase;
              }
          }
      }
    }
}    
</style>

